import React from "react";
import middleware from "./middlewares/middleware";
import AllPrivateNotification from "../component/sections/user/manage/private-notification/All";
import AddPrivateNotification from "../component/sections/user/manage/private-notification/Add";
import EditPrivateNotification from "../component/sections/user/manage/private-notification/Edit";
import AllPrivateNotificationUser from "../component/sections/user/private-notification/All";

const notificationPrivateRoutes = [
  {
    path: "/user/notification-private/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPrivateNotification />,
        "AllPrivateNotification"
      );
    },
    exact: true,
  },
  {
    path: "/user/notification-private/edit/:privateNotificationID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditPrivateNotification />,
        "EditPrivateNotification"
      );
    },
    exact: true,
  },
  {
    path: "/user/notification-private/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddPrivateNotification />,
        "AddPrivateNotification"
      );
    },
    exact: true,
  },
  {
    path: "/notification-private",
    render: () => {
      return middleware(
        ["isUserLogin"],
        <AllPrivateNotificationUser />,
        "Logout"
      );
    },
    exact: true,
  },
];

export default notificationPrivateRoutes;
